import ProcurementDashboard from "./ProcurementDashboard";

// Warehouse / Store Department Dashboard — replaces Inventory + Procurement
// Role: "warehouse"
// Reuses the Procurement Dashboard UI which has full inventory management.
export default ProcurementDashboard;
